<template>
  <div style="width:100%;padding-top:10px;">
    <!-- biểu đồ -->
    <div id="chartContainer" style="height: 370px; width: 100%;"></div>
  </div>
</template>

<script>
import chartBarJS from "./DefaultBarCharts";
// import chartBarLineJS from "./DefaultBarChartsLine";

export default {
  // name: "chart-bar",
  props: ["configBarChart", "typeChart"],
  methods: {
    displayCharts() {
      // if (this.typeChart && this.typeChart == "Line") {
      //   chartBarLineJS.chartJS(this.configBarChart);
      // } 
      // else chartBarJS.chartJS(this.configBarChart);
      
      chartBarJS.chartJS(this.configBarChart);
    }
  },
  data: function() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped>
.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
/* .card-body{
  min-height: 87vh;
} */
</style>
